"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _yaml = _interopRequireDefault(require("highlight.js/lib/languages/yaml"));
var _default = exports["default"] = _yaml["default"];